export const INN_MAX_LENGTH = 12;
export const INN_PATTERN = /^(\d{10}|\d{12})$/;
